import CSRF from 'csrf'
import updateAnswerCount from './updateAnswerCount'
import TextareaInitializer from 'textarea-initializer'
import MarkdownInitializer from 'markdown-initializer'
import autosize from 'autosize'
import ImageModalViewer from 'image-modal-viewer'

export default function initializeAnswer(answer) {
  const questionId = answer.dataset.question_id
  const answerId = answer.dataset.answer_id
  let savedAnswer = ''
  TextareaInitializer.initialize(`#js-comment-${answerId}`)
  const markdownInitializer = new MarkdownInitializer()
  const imageModalViewer = new ImageModalViewer()

  const answerDisplay = answer.querySelector('.answer-display')
  const answerEditor = answer.querySelector('.answer-editor')
  const answerDisplayContent = answerDisplay.querySelector('.a-long-text')

  const answerDescription = answerDisplayContent.textContent
  if (answerDescription) {
    markdownInitializer.setRenderHTML(answerDisplayContent, answerDescription)
    imageModalViewer.initialize()
  }

  const editButton = answerDisplay.querySelector('.card-main-actions__action')
  const modalElements = [answerDisplay, answerEditor]
  if (editButton) {
    editButton.addEventListener('click', () => {
      if (!savedAnswer) {
        savedAnswer = editorTextarea.value
      }
      toggleVisibility(modalElements, 'is-hidden')

      // NEXTRIBE: 初期処理後、入力内容の高さに応じて高さを調整
      autosize(editorTextarea)
      autosize.update(editorTextarea)
      const e = new Event('input');
      editorTextarea.dispatchEvent(e);
    })
  }

  const saveButton = answerEditor.querySelector('.is-primary')
  if (saveButton) {
    saveButton.addEventListener('click', () => {
      toggleVisibility(modalElements, 'is-hidden')
      savedAnswer = editorTextarea.value
      updateAnswer(answerId, savedAnswer)
      markdownInitializer.setRenderHTML(answerDisplayContent, savedAnswer)
      imageModalViewer.initialize()
    })
  }

  const answerEditorPreview = answerEditor.querySelector(
    '.a-markdown-input__preview'
  )
  const editorTextarea = answerEditor.querySelector(
    '.a-markdown-input__textarea'
  )

  const cancelButton = answerEditor.querySelector('.is-secondary')
  cancelButton.addEventListener('click', () => {
    toggleVisibility(modalElements, 'is-hidden')
    editorTextarea.value = savedAnswer
    markdownInitializer.setRenderHTML(answerEditorPreview, savedAnswer)
  })

  editorTextarea.addEventListener('input', () => {
    markdownInitializer.setRenderHTML(answerEditorPreview, editorTextarea.value)
  })

  const bestAnswerButton = answerDisplay.querySelector('.is-warning')
  const makeBestAnswerButton = answerDisplay.querySelector('.js-make-best-answer')

  const cancelBestAnswerButton = answerDisplay.querySelector('.is-muted')
  const answerBadgeElement = answerDisplay.querySelector('.answer-badge')
  if (makeBestAnswerButton) {
    makeBestAnswerButton.addEventListener('click', (event) => {
      event.preventDefault();

      if (window.confirm('本当に宜しいですか？')) {
        const form = makeBestAnswerButton.closest('form');
        const resolutionMethodInput = form.querySelector('input[name="answer[resolution_method]"]:checked');
        if (!resolutionMethodInput) {
          alert('解決方法を選択してください。');
          return;
        }
        const resolutionMethod = resolutionMethodInput.value;
        const resolutionReason = form.querySelector('textarea[name="answer[resolution_reason]"]').value;

        makeToBestAnswer(answerId, questionId, resolutionMethod, resolutionReason)

        // リロードさせる
        return;

        answerBadgeElement.classList.remove('is-hidden')
        answerBadgeElement.classList.add('correct-answer')
        const parentElements = [
          bestAnswerButton.parentNode,
          cancelBestAnswerButton.parentNode
        ]
        toggleVisibility(parentElements, 'is-hidden')
        const otherMakeBestAnswerButtons = document.querySelectorAll(
          '.make-best-answer-button'
        )
        otherMakeBestAnswerButtons.forEach((button) => {
          if (button.closest('.answer').dataset.answer_id !== answerId) {
            button.classList.add('is-hidden')
          }
        })
      }
    })
  }
  if (cancelBestAnswerButton) {
    cancelBestAnswerButton.addEventListener('click', () => {
      if (window.confirm('本当に宜しいですか？')) {
        cancelBestAnswer(answerId, questionId)

        // リロードさせる
        return;

        answerBadgeElement.classList.remove('correct-answer')
        answerBadgeElement.classList.add('is-hidden')
        const parentElements = [
          bestAnswerButton.parentNode,
          cancelBestAnswerButton.parentNode
        ]
        toggleVisibility(parentElements, 'is-hidden')
        const otherCancelBestAnswerButtons = document.querySelectorAll(
          '.make-best-answer-button'
        )
        otherCancelBestAnswerButtons.forEach((button) => {
          if (button.closest('.answer').dataset.answer_id !== answerId) {
            button.classList.remove('is-hidden')
          }
        })
      }
    })
  }

  const deleteButton = answerDisplay.querySelector(
    '.card-main-actions__muted-action'
  )
  if (deleteButton) {
    deleteButton.addEventListener('click', () => {
      if (window.confirm('本当に宜しいですか？')) {
        deleteAnswer(answerId)
        if (answerBadgeElement.classList.contains('correct-answer')) {
          cancelBestAnswer(answerId, questionId)
          const otherCancelBestAnswerButtons = document.querySelectorAll(
            '.make-best-answer-button'
          )
          otherCancelBestAnswerButtons.forEach((button) => {
            if (button.closest('.answer').dataset.answer_id !== answerId) {
              button.classList.remove('is-hidden')
            }
          })
        }

        // リロードさせる
        window.location.reload();
        return;
      }
    })
  }

  const editTab = answerEditor.querySelector('.edit-answer-tab')
  const editorTabContent = answerEditor.querySelector('.is-editor')
  const previewTab = answerEditor.querySelector('.answer-preview-tab')
  const previewTabContent = answerEditor.querySelector('.is-preview')

  const tabElements = [editTab, editorTabContent, previewTab, previewTabContent]
  editTab.addEventListener('click', () =>
    toggleVisibility(tabElements, 'is-active')
  )

  previewTab.addEventListener('click', () =>
    toggleVisibility(tabElements, 'is-active')
  )

  const createdAtElement = answer.querySelector('.thread-comment__created-at')
  if (createdAtElement && navigator.clipboard) {
    createdAtElement.addEventListener('click', () => {
      const answerURL = location.href.split('#')[0] + '#answer_' + answerId
      navigator.clipboard
        .writeText(answerURL)
        .then(() => {
          createdAtElement.classList.add('is-active')
          setTimeout(() => {
            createdAtElement.classList.remove('is-active')
          }, 4000)
        })
        .catch((error) => {
          console.error(error)
        })
    })
  }

  function toggleVisibility(elements, className) {
    elements.forEach((element) => {
      element.classList.toggle(className)
    })
  }

  function updateAnswer(answerId, description) {
    if (description.length < 1) {
      return null
    }
    const params = {
      id: answerId,
      answer: { description: description }
    }
    fetch(`/api/answers/${answerId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': CSRF.getToken()
      },
      credentials: 'same-origin',
      redirect: 'manual',
      body: JSON.stringify(params)
    }).catch((error) => {
      console.warn(error)
    })
  }

  function deleteAnswer(answerId) {
    fetch(`/api/answers/${answerId}.json`, {
      method: 'DELETE',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': CSRF.getToken()
      },
      credentials: 'same-origin',
      redirect: 'manual'
    })
      .then((response) => {
        if (response.ok) {
          window.location.reload();
        } else {
          alert('エラーが発生しました')
        }
        return;

        const deletedAnswer = document.querySelector(
          `.thread-comment.answer[data-answer_id='${answerId}']`
        )

        if (deletedAnswer) {
          deletedAnswer.parentNode.removeChild(deletedAnswer)
        }

        updateAnswerCount(false)
        imageModalViewer.initialize()
      })
      .catch((error) => {
        console.warn(error)
      })
  }

  function makeToBestAnswer(answerId, questionId, resolutionMethod, resolutionReason) {
    requestSolveQuestion(answerId, questionId, false, resolutionMethod, resolutionReason)
      .then((response) => {
        //solveQuestion()
        // リロードさせる
        if (response.ok) {
          window.location.reload();
        } else {
          alert('エラーが発生しました')
        }
      })
      .catch((error) => {
        console.warn(error)
      })
  }

  function cancelBestAnswer(answerId, questionId) {
    requestSolveQuestion(answerId, questionId, true)
      .then((response) => {
        if (response.ok) {
          window.location.reload();
        } else {
          alert('エラーが発生しました')
        }
        //cancelSolveQuestion()
      })
      .catch((error) => {
        console.warn(error)
      })
  }

  function requestSolveQuestion(answerId, questionId, isCancel, resolutionMethod, resolutionReason) {
    const params = {
      question_id: questionId,
      resolution_method: resolutionMethod,
      resolution_reason: resolutionReason,
    }

    return fetch(`/api/answers/${answerId}/correct_answer`, {
      method: isCancel ? 'PATCH' : 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': CSRF.getToken()
      },
      credentials: 'same-origin',
      redirect: 'manual',
      body: JSON.stringify(params)
    })
  }

  // リロードするようにしたため未使用
  // function solveQuestion() {
  //   const statusLabel = document.querySelector('.js-solved-status')
  //   statusLabel.classList.remove('is-danger')
  //   statusLabel.classList.add('is-success')
  //   statusLabel.textContent = '解決済'
  // }
  // function cancelSolveQuestion() {
  //   const statusLabel = document.querySelector('.js-solved-status')
  //   statusLabel.classList.remove('is-success')
  //   statusLabel.classList.add('is-danger')
  //   statusLabel.textContent = '未解決'
  // }
}
